import {Component, ViewEncapsulation} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../../../shared/store/store";
import {Observable} from "rxjs";
import {selectNotificationsLoading} from "../../../../shared/store/notificationCenter/notificationCenter.selectors";

@Component({
  selector: 'app-notifications-widget',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent {
  public readonly loading$: Observable<boolean> = this._store.select(selectNotificationsLoading);

  constructor(
    private readonly _store: Store<AppState>
  ) {}
}
